
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const photoApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listPhotos: builder.query ({
      query: (params) => `v2/photo/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Photo"]
    }),
    getPhoto: builder.query ({
      query: (photo_id) => `v2/photo/${photo_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Photo"]
    }),

    updatePhoto: builder.mutation ({
      query: ({photo_id, data}) => ({
        url: `v2/photo/${photo_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Photo"]
    }),
    deletePhoto: builder.mutation ({
      query: (photo_id) => ({
        url: `v2/photo/${photo_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Photo"]
    }),
    createPhoto: builder.mutation ({
      query: (data) => ({
        url: `v2/photo/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Photo"]
    }),
  })
})


export const {
  useListPhotosQuery,
  useLazyListPhotosQuery,
  useGetPhotoQuery,
  useLazyGetPhotoQuery,

  useUpdatePhotoMutation,
  useDeletePhotoMutation,
  useCreatePhotoMutation
} = photoApi
